import type {
	SensorGroupConfig,
	SensorV2,
	SharedStoreState,
} from '@innovyze/stylovyze';

/** Selects sensors from stylovyze's shared `sensors` store. */
export function selectSharedSensors(
	state: SharedStoreState,
): SensorV2[] | undefined {
	return state?.sensors?.sensors;
}

/** Selects the `initialized` property of the shared `sensors` store. */
export function selectSharedSensorsInitialized(state: SharedStoreState) {
	return state?.sensors?.initialized;
}

/** Selects sensor groups from stylovyze's shared `sensorGroups` store. */
export function selectSharedSensorGroups(
	state: SharedStoreState,
): SensorGroupConfig[] | undefined {
	return state?.sensorGroup?.sensorGroups?.sensorGroups;
}

/** Selects the `status` property of the shared `sensorGroups` store. */
export function selectSharedSensorGroupsStatus(state: SharedStoreState) {
	return state?.sensorGroup?.sensorGroups?.status;
}
